/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { getClientList, getLocations } from 'store/clientSlice';
import { Box } from 'atoms';
import { ClientContractForm } from 'components/forms';
import { getVehicalList } from 'store/vehicleSlice';
import { search_type } from 'utils';

export default function CreateClientContractPage() {
	const [formData, setFormData] = useState({});
	const [vehicleData, setVehicledata] = useState('');
	const { cities = [], statesWithCites } = useSelector((state) => state.clientState);
	console.log('statesWithCites', statesWithCites);

	const dispatch = useDispatch();
	const { id } = useParams();
	useEffect(() => {
		dispatch(
			getVehicalList({
				search_type: 'vehicle',
				filter_by: {},
			})
		)
			.then((res) => {
				console.log(res);
				const data = res?.rows?.map((item) => ({
					value: item?.vehicle_type,
					label: item?.vehicle_type,

					item,
				}));
				setVehicledata(data);
			})
			.finally(() => {});
		dispatch(
			getLocations({
				search_type: search_type?.location,
				filter_by: {},
			})
		);
	}, [dispatch]);

	useEffect(() => {
		if (id) {
			dispatch(
				getClientList({
					search_type: 'client_contract',
					filter_by: {
						id,
					},
				})
			).then((res) => {
				console.log('res', res);
				setFormData(res?.data?.[0]);
			});
		}
	}, [dispatch, id]);

	return (
		<Box>
			<ClientContractForm
				isEditMode={Boolean(formData?.id)}
				formData={formData}
				vehicleData={vehicleData}
				cites={cities}
			/>
		</Box>
	);
}
